module.exports = __webpack_public_path__ + "img/bar-chart-grouped-dark-02.264e6a97.jpg";